var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 69,
    viewBox: "0 0 77 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.258789,
    y: 0.59375,
    width: 76.4828,
    height: 67.8893,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2793,
    y: 60.5439,
    width: 14.0362,
    height: 60.155,
    transform: "rotate(-90 8.2793 60.5439)",
    fill: "#F1F3F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2793,
    y: 41.6152,
    width: 34.0879,
    height: 60.155,
    transform: "rotate(-90 8.2793 41.6152)",
    fill: "#FDF6F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6885 18.4961H33.822C32.5299 18.4961 31.4827 19.522 31.4827 20.7877V28.8084C31.4827 30.0741 32.5299 31.1 33.822 31.1H46.6885C47.9807 31.1 49.0279 30.0741 49.0279 28.8084V20.7877C49.0279 19.522 47.9788 18.4961 46.6885 18.4961ZM47.2734 28.8084C47.2734 29.1243 47.011 29.3813 46.6885 29.3813H46.1037L42.1085 23.62C41.9988 23.4625 41.8161 23.3658 41.6187 23.3658C41.4231 23.3658 41.2404 23.4615 41.1322 23.6209L38.8389 26.9907L38.0219 25.8937C37.9123 25.7433 37.7368 25.6574 37.5504 25.6574C37.3637 25.6574 37.188 25.7448 37.0778 25.8928L34.4069 29.3813H33.822C33.4996 29.3813 33.2372 29.1243 33.2372 28.8084V20.7877C33.2372 20.4718 33.4996 20.2148 33.822 20.2148H46.6885C47.011 20.2148 47.2734 20.4718 47.2734 20.7877V28.8084ZM36.1614 21.3606C35.5155 21.3606 34.9917 21.8737 34.9917 22.5064C34.9917 23.1391 35.5155 23.6522 36.1614 23.6522C36.8077 23.6522 37.3311 23.1391 37.3311 22.5064C37.3311 21.8737 36.8084 21.3606 36.1614 21.3606ZM44.6416 34.5374H32.3599C29.9413 34.5374 27.9736 32.611 27.9736 30.2407V21.6471C27.9736 21.1744 28.3666 20.7877 28.8509 20.7877C29.3352 20.7877 29.7282 21.1744 29.7282 21.6471V30.2407C29.7282 31.6622 30.9088 32.8187 32.3599 32.8187H44.6416C45.1259 32.8187 45.5189 33.2036 45.5189 33.6781C45.5189 34.1525 45.1277 34.5374 44.6416 34.5374Z",
    fill: "#CC5803"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuImage);
export default __webpack_public_path__ + "static/media/MenuImage.7476499730e5da3a58267d853025bc26.svg";
export { ForwardRef as ReactComponent };